import { render } from "./IDFRoomsModule.vue?vue&type=template&id=0a6b7865&scoped=true"
import script from "./IDFRoomsModule.vue?vue&type=script&lang=js"
export * from "./IDFRoomsModule.vue?vue&type=script&lang=js"

import "./IDFRoomsModule.vue?vue&type=style&index=0&id=0a6b7865&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0a6b7865"

export default script